export function validateNip(nip: string): boolean {
  if (typeof nip !== 'string') return false;
  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const nipWithoutDashes = nip.replace(/[\s-]/g, '');

  if (nipWithoutDashes.length === 10 && Number.parseInt(nipWithoutDashes, 10) > 0) {
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += Number(nipWithoutDashes[i]) * weights[i];
    }
    return (sum % 11) === Number(nipWithoutDashes[9]);
  }
  return false;
}
